import React from 'react';
import { Check } from 'lucide-react';
export function HeroSection() {
  return <section className="relative pt-12 pb-20 px-4 md:pt-20 md:pb-32 overflow-hidden" data-id="element-49">
      <div className="max-w-4xl mx-auto text-center" data-id="element-50">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#2D3648] mb-6 leading-tight" data-id="element-51">
          Tu hijo no odia leer. <br className="hidden md:block" data-id="element-52" />
          <span className="text-[#5C6B60] italic" data-id="element-53">Odia sentirse incapaz.</span>
        </h1>

        <p className="text-lg md:text-xl text-[#4A5568] mb-8 max-w-2xl mx-auto leading-relaxed" data-id="element-54">
          En solo 21 días, dedicando apenas 10 minutos por día, podés
          transformar esa frustración en confianza real.
        </p>

        <div className="flex flex-wrap justify-center gap-4 md:gap-8 mb-12 text-sm md:text-base font-medium text-[#5C6B60]" data-id="element-55">
          {['Sistema guiado paso a paso', 'Sin peleas', 'Sin presión', 'Sin improvisar'].map(item => <div key={item} className="flex items-center bg-white/50 px-3 py-1.5 rounded-full border border-[#5C6B60]/20" data-id="element-56">
              <Check className="w-4 h-4 mr-2 text-[#C2644C]" data-id="element-57" />
              {item}
            </div>)}
        </div>

        {/* Hero Image */}
        <div className="relative mx-auto mt-12 max-w-[90%] md:max-w-2xl" data-id="element-58">
          <div className="aspect-[4/5] md:aspect-[16/9] relative rounded-2xl overflow-hidden shadow-2xl ring-1 ring-black/5" data-id="element-59">
            <img src="https://cdn.magicpatterns.com/uploads/vHABiSaVweQr53fJErWyVX/mama_e_hijo.jpg" alt="Madre e hijo leyendo juntos en un ambiente tranquilo" className="w-full h-full object-cover" data-id="element-60" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent pointer-events-none" data-id="element-61" />
          </div>

          {/* Decorative elements */}
          <div className="absolute -z-10 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-[#C2644C]/5 blur-3xl rounded-full" data-id="element-62" />
        </div>
      </div>
    </section>;
}